import axios from 'axios'

export default {
    namespaced: true,
    state: {
        sources: [],
        loadingSources: false
    },
    mutations: {
        SET_SOURCES(state, sources){
            state.sources = sources;
        },
        SET_LOADSOURCES(state, loadingSources){
            state.loadingSources = loadingSources;
        }
    },
    getters: {
        sources: state => state.sources,
        loadingSources: state => state.loadingSources
    },
    actions: {
        loadSources({commit}) {
            return new Promise(resolve => {
                commit("SET_LOADSOURCES", true);
                axios.get("/source/get-all").then(res => {
                    commit("SET_SOURCES", res.data.sources);
                    commit("SET_LOADSOURCES", false);
                    resolve(res.data.sources);
                }).catch((e) => {
                    console.log(e);
                    commit("SET_LOADSOURCES", false);
                });
            });
        }
    },
}

